import React from 'react';
import { ReviewContactDetailsView } from 'pages/components';

const ContactsNewReview = (props) => (
  <ReviewContactDetailsView {...props} />
);

export default ContactsNewReview;
